module.exports = __webpack_public_path__ + "img/20191109144407566.12a6fd4d.jpg";